module.exports = __webpack_public_path__ + "img/options4_2.49dbf46e.png";